module.exports = __webpack_public_path__ + "resources/img/certi_iso_iec_22301.cbc707b03ef71c3ac15e420ba07ee8b1.png";